import { createFileRoute, Link } from "@tanstack/react-router";
import { SetupCopyBlock } from "@/components/setup/SetupCopyBlock";

export const Route = createFileRoute("/docs/editing-posts")({
	component: EditingPosts,
});

function EditingPosts() {
	return (
		<article className="space-y-10">
			<div className="space-y-2">
				<h1 className="text-2xl font-medium tracking-tight">Editing posts</h1>
				<p className="text-sm text-muted-foreground">
					How to update existing posts.
				</p>
			</div>
			<div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
				<p>Tell your assistant things like:</p>
				<div className="grid gap-2">
					<SetupCopyBlock
						text="Update my latest draft to mention the discount code SPRING20."
						multiline
					/>
					<SetupCopyBlock
						text="Change the scheduled post about the webinar to go out at 2pm instead."
						multiline
					/>
				</div>
				<p>
					The assistant uses{" "}
					<code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground">
						postPlan
					</code>{" "}
					to find the right post, then{" "}
					<code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground">
						postCompose
					</code>{" "}
					to make the changes. Published targets are edited live where the
					platform supports it; target selection and scheduling are locked after
					publish.
				</p>
				<p>
					If a platform does not support live edits, AgentReacher still keeps
					the updated copy in the workspace for future reference. Some
					target-specific settings, such as board selection, must be set when
					the post is created.
				</p>
			</div>

			<div className="flex items-center gap-4 text-sm">
				<Link
					to="/docs/creating-posts"
					className="text-muted-foreground hover:text-foreground transition-colors"
				>
					&larr; Creating posts
				</Link>
				<Link
					to="/docs/deleting-posts"
					className="text-primary hover:text-primary/80 transition-colors ml-auto"
				>
					Deleting posts &rarr;
				</Link>
			</div>
		</article>
	);
}
